<!-- Keymap Label Form -->
@if (keymapLabelForm) {
  <medsurf-design-form-control-form
    [formGroup]="keymapLabelForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-1 flex-row column-gap-2 align-items-center">
      <!-- Index -->
      <medsurf-design-form-control-input-text [formField]="false"
        [control]="keymapLabelForm.controls.index"
        [class]="'w-6rem'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
      <!-- Text -->
      <medsurf-design-form-control-input-text [formField]="false"
        [control]="keymapLabelForm.controls.text"
        [class]="'flex flex-grow-1'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
      <!-- Delete -->
      <button medsurf-design-input-button [id]="'label_remove'"
        [title]="'global.label_remove' | translate"
        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
      (click)="removeKeymapLabel()"></button>
    </div>
  </medsurf-design-form-control-form>
}